import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../zodios/client";

const REFETCH_INTERVAL_IN_SECONDS = 60;

type VideoGenTaskQueries = NonNullable<Parameters<typeof apiClient.getVideoGenerationResults>[0]>["queries"];

export const useGetAiVideoGenRequests = (queries: VideoGenTaskQueries = {}) => {
  return useQuery({
    queryKey: ["videoGenTaskResults", queries],
    queryFn: async () => await apiClient.getVideoGenerationResults({ queries }),
    refetchInterval: REFETCH_INTERVAL_IN_SECONDS * 1000,
    refetchIntervalInBackground: true,
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
};
